import {ContactInformationAttributes} from '@treez/commons/sharedTypings/directory';
import {PriceTierWithHasProductsFlag} from '@treez/commons/sharedTypings/priceTier';
import {OrganizationAction} from '~/redux/actions/OrganizationActions';
import {StoreAttributes} from '~/lib/directory';

export interface OrganizationState {
    contactInformation?: ContactInformationAttributes[];
    didInvalidate: boolean;
    isFetching: boolean;
    organizationCatalogId: number;
    organizationId: number;
    organizationName: string;
    selectedCatalogs: number[];
    stores?: StoreAttributes[];
    priceTiers?: PriceTierWithHasProductsFlag[];
}

export const DEFAULT_ORG_STATE = {
    contactInformation: [],
    didInvalidate: false,
    isFetching: false,
    organizationCatalogId: 0,
    organizationId: 0,
    organizationName: '',
    stores: [],
    priceTiers: [],
};

const {
    INVALIDATE_ORGANIZATION_REQUEST,
    LOAD_ORGANIZATION,
    REQUEST_ORGANIZATION,
    UPDATE_PRICE_TIERS,
    UPDATE_PRICE_TIER,
} = OrganizationAction;

const OrganizationReducer = (state = DEFAULT_ORG_STATE, action) => {
    const {type: typeOfAction, value} = action;

    switch (typeOfAction) {
        case INVALIDATE_ORGANIZATION_REQUEST:
            return {
                ...state,
                didInvalidate: true,
                isFetching: false,
            };
        case LOAD_ORGANIZATION:
            const {catalogId, contactInformation, typeId, name, stores, priceTiers} = value;
            return {
                ...state,
                contactInformation,
                isFetching: false,
                organizationCatalogId: catalogId,
                organizationId: typeId,
                organizationName: name,
                stores,
                priceTiers,
            };
        case REQUEST_ORGANIZATION:
            return {
                ...state,
                isFetching: true,
            };
        case UPDATE_PRICE_TIERS:
            return {
                ...state,
                priceTiers: value,
            };
        case UPDATE_PRICE_TIER:
            const newPriceTiers = state.priceTiers.map(
                (priceTier: PriceTierWithHasProductsFlag) => {
                    if (priceTier.id === value.id) {
                        return value;
                    }
                    return priceTier;
                }
            );

            return {
                ...state,
                priceTiers: newPriceTiers,
            };
        default:
            return state;
    }
};

export default OrganizationReducer;
